import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { useAnalytics } from './useAnalytics';

export const RouteChangeTracker = () => {
  const location = useLocation();

  const { page } = useAnalytics();

  useEffect(() => {
    page();
  }, [location.pathname]);

  return null;
};
